import React from 'react';
import { Stack, Typography, Box, Divider } from '@mui/material';
import {
  dottedDividerStyles,
  instructionTextStyle,
} from 'pages/Forms/Theme/responseInputStyles';
import { FieldResultProps } from 'pages/Forms/FormResults/types/types';
import { FieldsInputTitle } from '../../common/FieldsInputTitle';
import { useInstructionUtils } from '../../../utils/useInstructionUtils';

export const InstructionResult: React.FC<FieldResultProps> = ({
  item,
  tableType = false,
}) => {
  const { attachFile, renderAttachment } = useInstructionUtils(item);

  return (
    <>
      <Box p={tableType ? 1 : 2}>
        {!tableType && <FieldsInputTitle label={item?.label || item?.name} />}
        <Typography variant="body2">
          <Box
            sx={instructionTextStyle}
            dangerouslySetInnerHTML={{
              __html: item?.description || item?.instruction || '',
            }}
          />
        </Typography>
        {attachFile?.map((attachment, index) => (
          <Stack key={index} mt={1}>
            {renderAttachment(attachment)}
          </Stack>
        ))}
      </Box>
      {!tableType && <Divider sx={dottedDividerStyles} />}
    </>
  );
};
